import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import {
  COMMON_STYLES,
  COMMON_VALIDATION,
  COMMON_VALIDATION_PARAM,
} from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { CheckBoxField } from './common/fields/CheckBoxField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'round',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      param: 0, 
      transformInPlace: false,
    },
  ],
};

const validationSchema = {
  ...COMMON_VALIDATION,
  ...COMMON_VALIDATION_PARAM('Enter number of decimal places (0 for nearest whole number)'),
};

const renderTransformationFields = ({
  formField,
  errors,
  setFieldValue,
  disableForm,
  headers,
}) => {
  const handleInPlaceChange = (index, value) => {
    const newTransforms = [...formField.transformations];
    newTransforms[index].transformInPlace = value;
    if (value) {
      newTransforms[index].outputColumn = '';
    }
    setFieldValue('transformations', newTransforms);
  };

  const renderField = ({ transform, index, headers, disableForm, errors }) => (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CheckBoxField
          checked={transform.transformInPlace}
          onChange={(value) => handleInPlaceChange(index, value)}
          disabled={disableForm}
        />
      </Grid>

      <Grid item {...COMMON_STYLES.gridItem}>
        <SourceColumnField
          value={transform.sourceColumns[0] || ''}
          onChange={(e) => {
            const newTransforms = [...formField.transformations];
            newTransforms[index].sourceColumns = [e.target.value];
            setFieldValue('transformations', newTransforms);
          }}
          headers={headers}
          disabled={disableForm}
          error={!!errors?.sourceColumns}
          helperText={
            errors?.sourceColumns ||
            (transform.transformInPlace
              ? 'This column will be modified directly'
              : 'Select numeric column to round')
          }
        />
      </Grid>

      <Grid item {...COMMON_STYLES.gridItem}>
        <OutputColumnField
          value={transform.param}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '' || Number(val) >= 0) {
              const newTransforms = [...formField.transformations];
              newTransforms[index].param = val;
              setFieldValue('transformations', newTransforms);
            }
          }}
          disabled={disableForm}
          label="Decimal Places *"
          helperText={
            errors?.param ||
            '0 = nearest whole number (e.g., 3.6 → 4), N = round to N decimals (e.g., 3.1415 → 3.14)'
          }
          type="number"
          error={!!errors?.param}
        />
      </Grid>

      {!transform.transformInPlace && (
        <Grid item {...COMMON_STYLES.gridItem}>
          <OutputColumnField
            value={transform.outputColumn || ''}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].outputColumn = e.target.value;
              setFieldValue('transformations', newTransforms);
            }}
            disabled={disableForm}
            error={!!errors?.outputColumn}
            helperText={errors?.outputColumn || 'Enter output column name'}
          />
        </Grid>
      )}
    </Grid>
  );

  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading
        title="Round - Round Off (3.6 → 4) or to Decimal (3.1415 → 3.14)"
        disabled={disableForm}
      />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) =>
          setFieldValue('transformations', newTransforms)
        }
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_Round = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Round"
  />
);

export default NodeModal_Round;
